import { FlexBox, SPACING } from "@joonapp/web-shared"

import ClientManagement from "./ClientManagement"
import PersonalInformation from "./PersonalInformation"
import SettingsHeader from "./SettingsHeader"
import PageWrapper from "../../components/pageWrapper/PageWrapper"

const Settings = () => {
  return (
    <PageWrapper>
      <SettingsHeader />
      <FlexBox direction="column" wrap={false} style={{ overflow: "auto" }}>
        <FlexBox
          direction="column"
          gap={SPACING.space8}
          style={{
            padding: SPACING.space6,
            width: "min(880px, 95vw)",
            margin: "0 auto",
          }}
        >
          <PersonalInformation />
          <ClientManagement />
        </FlexBox>
      </FlexBox>
    </PageWrapper>
  )
}

export default Settings
